import React from 'react';
import PropTypes from 'prop-types';
import BEMHelper from '@ynap/bem-helper';

const bem = new BEMHelper('Flag');

const propTypes = {
    countryISO: PropTypes.string.required,
    className: PropTypes.string,
    useSvg: PropTypes.bool,
};

function Flag({ className, countryISO, useSvg }) {
    return <span className={bem('container', null, [countryISO, className, useSvg && 'icon'])} />;
}

Flag.propTypes = propTypes;

export default Flag;
